import { Link } from 'react-router';
import { SALE_STATUS_LABELS } from '@agencia/shared';
import type { SaleRow } from '@/lib/types';

/** Situação da venda; "Informar custo" vira link quando a pessoa pode lançar. */
export function SaleStatusCell({ sale, mine }: { sale: SaleRow; mine: boolean }) {
  if (sale.status === 'AGUARDANDO_CUSTO') {
    return mine && sale.editavel !== false ? (
      <Link to={`/vendas/${sale.id}`} className="badge badge--action">
        Informar custo
      </Link>
    ) : (
      <span className="badge badge--warn">Sem custo</span>
    );
  }
  const tone = sale.status === 'CUSTO_INFORMADO' ? 'ok' : 'off';
  return <span className={`badge badge--${tone}`}>{SALE_STATUS_LABELS[sale.status]}</span>;
}
